import { createSlice } from '@reduxjs/toolkit';

type DiplomaTypes = {
  id: number;
  pinfl: string;
  edu_type_id: number;
  edu_type_name: string;
  institution_type_id: number;
  institution_type_name: string;
  institution_id: number;
  institution_name: string;
  institution_old_name_id: number;
  institution_old_name: string;
  degree_id: number;
  degree_name: string;
  edu_form_id: number;
  edu_form_name: string;
  speciality_id: number;
  speciality_old_id: number;
  speciality_name: string;
  speciality_code: string;
  edu_duration_id: string;
  edu_duration_name: string;
  edu_starting_date: string;
  edu_finishing_date: string;
  diploma_given_date: string;
  diploma_serial_id: number;
  diploma_serial: string;
  diploma_number: string;
  diploma_type_id: number;
  diploma_type_name: string;
  status_id: number;
  status_name: string;
};

type RequestCommandState = {
  loading: boolean;
  data: DiplomaTypes[];
};

let data;

const initialState: RequestCommandState = {
  loading: false,
  data: [],
};
export const diplomaInfosSlice = createSlice({
  name: 'integrationsDiplomaInfos',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export default diplomaInfosSlice.reducer;
